import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { ErrorMessages } from '../../../../common/components';
import { ChildPageHeading } from '../../../../common/components/ChildPageHeading';
import { Routes } from '../../../../config/routes';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { useNewsNew, useUpdateNewsNew } from '../../../../services/news-new';
import { NewsNewForm } from '../NewsNewForm/NewsNewForm';

export const UpdateNewsNew = () => {
  const { id } = useParams<{ id: string }>();
  invariant(id, 'id is not set within the route');
  const translations = useTranslations();
  const navigate = useNavigate();
  const { data: news, isLoading: isLoadingNews, error: loadError } = useNewsNew(id);
  const { mutate: updateNews, isLoading: isUpdatingNews, error: updateError } = useUpdateNewsNew();

  return (
    <>
      <ChildPageHeading>{translations('news_new_update')}</ChildPageHeading>
      <ErrorMessages errors={[updateError, loadError]} />
      <NewsNewForm
        model={news}
        isLoading={isUpdatingNews || isLoadingNews}
        onSubmit={(updateNewsRequest) =>
          updateNews(
            { id, request: updateNewsRequest },
            {
              onSuccess: () => navigate(Routes.NEWS_NEW_PATH),
            },
          )
        }
      />
    </>
  );
};
